<script >
import {
  VAutocomplete,
  VDivider, VForm, VSelect,
  VStepper,
  VStepperContent,
  VStepperHeader,
  VStepperItems, VStepperStep,
} from 'vuetify/lib/components'
import NavMenuSectionTitle from '@/layouts/components/vertical-nav-menu/components/NavMenuSectionTitle.vue';
import {mdiCloseCircle} from '@mdi/js'
import {VTextField, VToolbar, VToolbarTitle} from 'vuetify'
import StayPaymentModel from '@/views/stay/StayPaymentModel'
import StayFullModel from '@/views/stay/StayFullModel'
import Stay from "@/views/stay/StayModel";
import * as moment from 'moment'
export default {
  name: 'NewStay',
  components: {
    VStepperItems,
    VStepperHeader,
    VStepper,
    mdiCloseCircle,
    VStepperContent,
    VTextField,
    VAutocomplete,
    VDivider,
    NavMenuSectionTitle,
    VStepperStep,
    VSelect,
    VToolbarTitle,
    VForm,
    VToolbar,
  },
  data() {
    return {
      e1: 1,
      room_list: [],
      client_list: [],
      payment_type_list: [],
      loading: false,
      stay_type_list: [],
      stay: StayFullModel,
      stay_resume: Stay,
      stay_payement: StayPaymentModel,

    }
  },
  mounted() {
    this.loadCustomer()
    this.loadRoom()
    this.loadPaymentType()
    this.loadStayTypes()
  },
  methods: {
    newStay() {
      this.loading = true;
      this.$axios.post(this.$endpoint.CreateStay, this.stay).then(rp => {
        this.createStay = false
        this.stay = StayFullModel
        this.loading = false;
        this.$router.push('/stay')
        window.open(rp.data.invoice, '_blank')
      })
    },
    // getRoomPrice(idRoom) {
    //
    // },
    // getStayPrice(roomPrice) {
    //
    // },
    intResume() {
      if (
        this.stay.stays_date.length <= 5
          || this.stay.stay_type_id === 0
          || this.stay.room_id === 0
          || this.stay.pay_stay_date.length <= 5
          || this.stay.payement_type_id === 0
      ) {
        this.$swal.fire({
          icon: 'error',
          title: 'Veuillez remplir correctement tout les champs',
          showConfirmButton: true,
          confirmButtonColor: '#C11E1F',
          confirmButtonText: 'Compris',
        })
      } else {
        this.$axios.get(this.$endpoint.CheckStayRoomAvailability(this.stay.room_id, this.stay.stays_enter_date, this.stay.stays_leaving_date)).then(resp_check => {
          const check_status = resp_check.data
          if (check_status.data === true) {
            this.$swal.fire({
              icon: 'error',
              title: check_status.message,
              showConfirmButton: true,
              confirmButtonColor: '#C11E1F',
              confirmButtonText: 'Compris',
            })
          } else {
            const tpStay = this.stay_type_list.find(tp => tp.id === this.stay.stay_type_id)
            if (tpStay !== undefined) {
              this.stay_resume.stayType = tpStay.stay_typ_name
            }
            const room = this.room_list.find(rm => rm.id === this.stay.room_id)
            const date1 = moment(this.stay.stays_enter_date)
            const dateNow = moment()
            this.stay.is_booking = date1 > dateNow
            // eslint-disable-next-line camelcase
            // eslint-disable-next-line camelcase
            this.stay_resume.stayNumber = this.stay.stays_number_of_days
            if (room !== undefined) {
              this.stay_resume.roomName = room.room_name
              this.stay_resume.roomType = room.room_type.room_type_name
              this.stay_resume.roomPrice = room.room_total_price
              this.stay_resume.stayTotalAmount = (room.room_total_price * this.stay_resume.stayNumber) + ((room.room_total_price * this.stay_resume.stayNumber) * (this.stay.stays_vat / 100))
              this.stay_resume.amount_reduce = ((room.room_total_price - this.stay.stays_reduce) * this.stay_resume.stayNumber) + ((room.room_total_price * this.stay_resume.stayNumber) * (this.stay.stays_vat / 100))
              this.stay_resume.stayAmountRemain = this.stay_resume.amount_reduce - this.stay.pay_stay_amount
              if (this.stay_resume.stayAmountRemain === 0) {
                this.stay_resume.staySold = 'Soldé'
              } else {
                this.stay_resume.staySold = 'Non-soldé'
              }
              const customer = this.client_list.find(ct => ct.id === this.stay.customer_id)
              if (customer !== undefined) {
                this.stay_resume.customerName = `${customer.cust_lastname} ${customer.cust_firstname}`
                this.stay_resume.customerPhone = customer.cust_contact
              }
            }
            this.e1 = 3
          }
        })
      }
    },
    loadCustomer() {
      this.$axios.get(this.$endpoint.LoadCustomer).then(rp => {
        this.client_list = rp.data
      })
    },
    loadRoom() {
      this.$axios.get(this.$endpoint.LoadRoom).then(rp => {
        this.room_list = rp.data
        this.room_list = this.room_list.filter(room => room.room_status === 400)
      })
    },
    loadStayTypes() {
      this.$axios.get(this.$endpoint.LoadStayType).then(rp => {
        this.stay_type_list = rp.data
      })
    },
    loadPaymentType() {
      this.$axios.get(this.$endpoint.LoadPaymentType).then(rp => {
        this.payment_type_list = rp.data
      })
    },
    stepOneValidator() {
      if (this.stay.customer_id === 0 || this.stay.stays_enter_date.length < 5 || this.stay.stays_leaving_date.length < 5 || this.stay.stays_number_of_occupants <= 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'Veuillez remplir correctement tout les champs',
          showConfirmButton: true,
          confirmButtonColor: '#C11E1F',
          confirmButtonText: 'Compris',
        })
      } else {
        const dt_one = moment(this.stay.stays_enter_date)
        const dt_two = moment(this.stay.stays_leaving_date)
        if (dt_one > dt_two) {
          this.$swal.fire({
            icon: 'error',
            title: "Veuillez bien renseigné l'intervalle de date",
            showConfirmButton: true,
            confirmButtonColor: '#C11E1F',
            confirmButtonText: 'Compris',
          })
        } else {
          this.stay.stays_number_of_days = dt_two.diff(dt_one, 'days')
          this.e1 = 2
        }
      }
    },
  },
}
</script>

<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar
            dark
            color="primary"
        >
          <v-btn
              color="primary"
              :to="'/stay'"
          >
            <mdi-close-circle />
            Annuler
          </v-btn>&emsp;
          <v-toolbar-title color="white">
            Enregistrer un nouveau séjour
          </v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step
                  :complete="e1 > 1"
                  step="1"
              >
                Infos relative au client
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                  :complete="e1 > 2"
                  step="2"
              >
                Infos relative au séjour
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="3">
                Resumé
              </v-stepper-step>
            </v-stepper-header>
            <v-form class="multi-col-validation">
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-row style="margin-top: 1%">
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-autocomplete
                          v-model="stay.customer_id"
                          dense
                          :items="client_list"
                          label="Client"
                          :item-value="'id'"
                          outlined
                          deletable-chips
                          filled
                          :item-text="
                              item => item.cust_lastname + ' ' + item.cust_firstname + '(' + item.cust_contact + ')'
                            "
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          v-model="stay.stays_enter_date"
                          dense
                          type="date"
                          hide-details
                          label="Date d'entrée"
                          outlined
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          v-model="stay.stays_leaving_date"
                          dense
                          type="date"
                          hide-details
                          label="Date de sortir"
                          outlined
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          v-model="stay.stays_number_of_occupants"
                          dense
                          type="number"
                          hide-details
                          label="Nombre d'occupants"
                          outlined
                          placeholder="occupants de la chambre"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          v-model="stay.stays_number_of_children"
                          dense
                          type="number"
                          hide-details
                          label="Nombre d'enfants"
                          outlined
                          placeholder="nombre de mineur"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-btn
                          style="margin-left: 1rem; margin-right: 1rem"
                          color="primary"
                          @click="stepOneValidator()"
                      >
                        Continuer
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-row style="margin-top: 1%">
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          v-model="stay.stays_date"
                          dense
                          type="date"
                          hide-details
                          label="Date d'enregistrement"
                          outlined
                          placeholder="Date de creation"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-select
                          v-model="stay.stay_type_id"
                          dense
                          :items="stay_type_list"
                          name="stay_type_list"
                          :item-text="item => item.stay_typ_name"
                          :item-value="'id'"
                          label="Type de séjour"
                          outlined
                      ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-select
                          v-model="stay.room_id"
                          dense
                          :items="room_list"
                          name="room_list"
                          :item-text="item => item.room_name +' ('+item.room_type.room_type_name+')'"
                          :item-value="'id'"
                          label="Chambre choisir"
                          outlined
                      ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          dense
                          type="text"
                          hide-details
                          label="Prix de la chambre"
                          outlined
                          disabled
                          :value="room_list.filter(c=>c.id===stay.room_id)[0]?room_list.filter(c=>c.id===stay.room_id)[0].room_total_price - stay.stays_reduce:''"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          dense
                          type="text"
                          hide-details
                          label="Prix du séjour"
                          outlined
                          disabled
                          :value="room_list.filter(c=>c.id===stay.room_id)[0]?(room_list.filter(c=>c.id===stay.room_id)[0].room_total_price - stay.stays_reduce)*stay.stays_number_of_days:''"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          dense
                          type="text"
                          hide-details
                          label="Nombre de nuitée"
                          outlined
                          disabled
                          :value="stay.stays_number_of_days"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          v-model="stay.stays_reduce"
                          dense
                          type="number"
                          label="Reduction"
                          outlined
                          placeholder="Montant de la reduction"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-textarea
                          v-model="stay.stays_preference"
                          dense
                          required
                          label="Préférence du client"
                          outlined
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <nav-menu-section-title title="Payement du Séjour"></nav-menu-section-title>
                  <v-row style="margin-top: 1%">
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          v-model="stay.pay_stay_date"
                          dense
                          type="date"
                          hide-details
                          label="Date du paiement"
                          outlined
                          placeholder="Date de paiement"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          v-model="stay.pay_stay_ref"
                          dense
                          hide-details
                          label="Reference du paiement"
                          outlined
                          placeholder="Reference"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          v-model="stay.pay_stay_amount"
                          dense
                          type="number"
                          hide-details
                          label="Montant du paiement"
                          outlined
                          placeholder="Montant"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-text-field
                          v-model="stay.stays_vat"
                          dense
                          type="number"
                          hide-details
                          label="TVA(en %)"
                          outlined
                          placeholder="exemple:0,5"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-select
                          v-model="stay.payment_type_id"
                          dense
                          :items="payment_type_list"
                          name="payment_type_list"
                          :item-text="item => item.pay_typ_name"
                          :item-value="'id'"
                          label="Methode de paiement"
                          outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-btn
                          color="primary"
                          @click="e1 = 1"
                      >
                        Precedent
                      </v-btn>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-btn
                          style="margin-left: 1rem; margin-right: 1rem"
                          color="primary"
                          @click="intResume"
                      >
                        Continuer
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <v-stepper-content step="3">
                  RESUME
                  <v-row align-content-md="center">
                    <v-col
                        cols="12"
                        md="6"
                    >
                      Details du Séjour:  <br>
                      <p><span>Date D'entré</span> :<strong>{{ stay.stays_enter_date }}</strong></p>
                      <p><span>Date de sortir</span> :<strong>{{ stay.stays_leaving_date }}</strong></p>
                      <p>
                        <span>Type de séjour</span> :<strong>
                        {{ stay_resume.stayType }}
                      </strong>
                      </p>
                      <p>
                        <span>Nom de la chambre</span> :<strong>
                        {{ stay_resume.roomName }}
                      </strong>
                      </p>
                      <p>
                        <span>Type de la chambre</span> :<strong>
                        {{ stay_resume.roomType }}
                      </strong>
                      </p>
                      <p>
                        <span>Nom du client</span> :<strong>
                        {{ stay_resume.customerName }}
                      </strong>
                      </p>
                      <p>
                        <span>Numéro du client</span> :<strong>
                        {{ stay_resume.customerPhone }}
                      </strong>
                      </p>
                      <p><span>Nombre d'occupants</span> :<strong>{{ stay.stays_number_of_occupants }}</strong></p>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      Details du S&eacute;jour:  <br>
                      <p>
                        <span>Nombre de nuitée(s)</span> :<strong>
                        {{ stay_resume.stayNumber }}
                      </strong>
                      </p>
                      <p>
                        <span>Prix de la chambre</span> :<strong>
                        {{ stay_resume.roomPrice }}
                      </strong>
                      </p>
                      <p><span>Tva</span> :<strong>{{ stay.stays_vat }}</strong></p>
                      <p><span>Montant total à payer</span> :<strong>{{ stay_resume.stayTotalAmount }}</strong></p>
                      <p><span>Montant de la reduction</span> :<strong>{{ stay.stays_reduce }} FCFA</strong></p>
                      <p><span>Montant total après reduction</span> :<strong>{{ stay_resume.amount_reduce }}</strong></p>
                      <p><span>Montant Payé;</span> :<strong>{{ stay.pay_stay_amount }}</strong></p>
                      <p><span>Montant restant : </span> :<strong>{{ stay_resume.stayAmountRemain }}</strong></p>
                      <p><span>Sold&eacute;</span> :<strong>{{ stay_resume.staySold }}</strong></p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-btn
                          color="primary"
                          @click="e1 = 2"
                      >
                        Precedent
                      </v-btn>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                      <v-btn
                          style="margin-left: 1rem; margin-right: 1rem"
                          color="primary"
                          @click="newStay"
                      >
                        {{ loading ? 'Veuillez Patienté ...' :'Valider' }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>
              </v-stepper-items>
            </v-form>
          </v-stepper>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>
